import React from 'react'
import DefaultLayout from '../DefaultLayout'

const ResolveProbremMessageWrapper = () => {
    return (
        <div className='bg-main-100 pt-14 sm:pt-20 sm:pt-40 text-main-800'>

            <DefaultLayout className='px-6'>
                <>
                    <div className='relative'>
                        <div className='flex justify-center'>
                            <img className='sm:absolute top-0 sm:-top-6 left-16 w-40 sm:w-40 mb-10' src='https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//ring.png' width={800} height={800} alt='バインスタリングの画像' />
                        </div>

                        <h2 className='text-center text-2xl sm:text-5xl font-semibold mb-4'>
                            「指輪型」という新しい解決策
                        </h2>
                        <p className='text-center text-lg font-semibold mb-20 sm:mb-40'>
                            単なる指輪ではありません。<br className='sm:hidden' />認証された医療機器です。<span className='text-sm'>※クラスⅡ</span><br />
                        </p>
                    </div>


                    <div className='grid grid-cols-1 sm:grid-cols-2 gap-x-24 gap-y-14 sm:gap-y-32'>
                        <div className='text-center mb-10'>
                            <h3 className='text-2xl sm:text-3xl font-semibold mb-4'>
                                確かな計測力
                            </h3>
                            <div className='w-full h-44 flex items-center bg-white mb-6'>
                                <img className='w-full' src='https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//measure_list.jpg' width={1200} height={300} alt='計測項目の一覧表画像' />
                            </div>
                            <p className='text-left'>
                                クラスⅡ管理医療機器のため、高精度で信頼性の高い解析が可能です。<br />
                                1秒ごとにデータを取得しているためより精緻に分析もできます。

                            </p>
                        </div>
                        <div className='text-center mb-10'>
                            <h3 className='text-2xl sm:text-3xl font-semibold mb-4'>
                                快適な装着感
                            </h3>
                            <div className='grid grid-cols-2 mb-6 sm:h-44'>
                                <img className='h-full w-full' src='https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//confortable1.png' width={400} height={400} alt='バインスタリング装着イメージ画像１' />
                                <img className='h-full w-full' src='https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//confortable2.png' width={400} height={400} alt='バインスタリング装着イメージ画像2' />
                            </div>
                            <p className='text-left'>
                                日常生活に支障がないよう、リングならではの軽量で装着感の良いデザインを実現しました。
                            </p>
                        </div>
                        <div className='text-center mb-10'>
                            <h3 className='text-2xl sm:text-3xl font-semibold mb-4'>
                                安心の価格帯
                            </h3>
                            <div className='grid grid-cols-2 gap-2 sm:gap-6 mb-6 h-44'>
                                <div>
                                    <h3 className='mb-2 text-main-800 font-semibold text-xs'>リング</h3>
                                    <table className="table-auto w-full text-sm text-center text-gray-500 mb-10">
                                        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                            <tr className='bg-main-600 text-white text-xs'>
                                                <th colSpan={3} className="py-3 text-center border-r border-white">種別</th>
                                                <th colSpan={7} className="py-3 text-center">価格（税抜）</th>
                                            </tr>
                                        </thead>
                                        <tbody className='text-xs border border-white text-main-800'>
                                            <tr className='bg-main-200 border border-white'>
                                                <td colSpan={3} className="py-3 border-r border-white">販売</td>
                                                <td colSpan={7} className="py-3">150,000円/個</td>
                                            </tr>
                                            <tr className='bg-main-100'>
                                                <td colSpan={3} className="py-3 border-r border-white">レンタル</td>
                                                <td colSpan={7} className="py-3">月額&nbsp;<br className='sm:hidden' />6,000円/個</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* <div className='text-center font-semibold text-xs border border-white'>
                                        <dl className='flex bg-main-600 text-white border-y-2 border-white'>
                                            <dt className='py-4 w-32 border-r-2 border-white'>価格</dt>
                                            <dd className='py-4 w-full'>価格（税抜）</dd>
                                        </dl>
                                        <dl className='flex bg-main-200 border-y-2 border-white'>
                                            <dt className='py-4 w-32 border-r-2 border-white'>販売</dt>
                                            <dd className='py-4 w-full'>150,000円/個</dd>
                                        </dl>
                                        <dl className='flex border-y-white border'>
                                            <dt className='py-4 w-32 border-r-2 border-white'>レンタル</dt>
                                            <dd className='py-4 w-full'>月額 &nbsp;<br className='sm:hidden'/>6,000円/個</dd>
                                        </dl>
                                    </div> */}

                                </div>
                                <div>
                                    <h3 className='mb-2 text-main-800 font-semibold text-xs'>充電ケース</h3>

                                    <table className="table-auto w-full text-sm text-center text-gray-500 mb-10">
                                        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                            <tr className='bg-main-600 text-white text-xs'>
                                                <th colSpan={3} className="py-3 text-center border-r border-white">種別</th>
                                                <th colSpan={7} className="py-3 text-center">価格（税抜）</th>
                                            </tr>
                                        </thead>
                                        <tbody className='text-xs border border-white text-main-800'>
                                            <tr className='bg-main-200 border border-white'>
                                                <td colSpan={3} className="py-3 border-r border-white">販売</td>
                                                <td colSpan={7} className="py-3">10,000円/個</td>
                                            </tr>
                                            <tr className='bg-main-100'>
                                                <td colSpan={3} className="py-3 border-r border-white">レンタル</td>
                                                <td colSpan={7} className="py-3">月額&nbsp;<br className='sm:hidden' />1,000円/個</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* <div className='text-center font-semibold text-xs border border-white'>
                                        <dl className='flex bg-main-600 text-white border-y-2 border-white'>
                                            <dt className='py-4 w-32 border-r-2 border-white'>価格</dt>
                                            <dd className='py-4 w-full'>価格（税抜）</dd>
                                        </dl>
                                        <dl className='flex bg-main-200 border-y-2 border-white'>
                                            <dt className='py-4 w-32 border-r-2 border-white'>販売</dt>
                                            <dd className='py-4 w-full'>10,000円/個</dd>
                                        </dl>
                                        <dl className='flex border-y-white border'>
                                            <dt className='py-4 w-32 border-r-2 border-white'>レンタル</dt>
                                            <dd className='py-4 w-full'>月額 &nbsp;<br className='sm:hidden'/>1,000円/個</dd>
                                        </dl>
                                    </div> */}
                                </div>
                            </div>
                            <p className='text-left'>
                                お客様に合わせてプランをご用意しております。またすばやくスタートできるように月額サブスクプランもご用意しております。
                            </p>
                        </div>
                        <div className='text-center mb-10'>
                            <h3 className='text-2xl sm:text-3xl font-semibold mb-4'>
                                簡単なデータ管理
                            </h3>
                            <div className='mb-6'>
                                <div className='px-4 mb-6 h-44'>
                                    <img className='h-full object-contain' src='https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//cloud1.png' width={1200} height={600} alt='クラウド管理画面画像' />
                                </div>
                                <p className='text-left'>
                                    クラウドにて複数ユーザーの一元管理が可能に。WEBサイトからユーザーのデータ確認・データダウンロードすることができます。<br />
                                    診断・結果確認までのリードタイムが早く多くのお客様にご提供することが可能です。
                                </p>
                            </div>
                        </div>
                    </div>

                </>
            </DefaultLayout>
        </div>
    )
}

export default ResolveProbremMessageWrapper